/* eslint-disable */
import { SVGProps } from "react";

const SvgElectrical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42.842}
    height={40.21}
    fill="currentColor"
    viewBox="0 0 42.842 40.21"
    {...props}
  >
    <path
      data-name="Path 554"
      d="M36.568 6.271a21.423 21.423 0 0 0-33.621 26 21.539 21.539 0 0 0 7.734 7.688 1.858 1.858 0 0 0 1.865-3.213 17.707 17.707 0 1 1 26.58-15.325c0 4.127-1.118 7.57-3.232 9.956a8.6 8.6 0 0 1-6.338 3.056 5.964 5.964 0 0 1-5.9-4.438 8.211 8.211 0 0 0 6.544-8.024v-5.418a.464.464 0 0 0-.464-.464h-2.487v-5.068a1.858 1.858 0 0 0-3.715 0v5.068h-4.226v-5.068a1.858 1.858 0 0 0-3.715 0v5.068h-2.485a.464.464 0 0 0-.464.464v5.418a8.209 8.209 0 0 0 7.217 8.138 10.369 10.369 0 0 0 2.695 5.185 9.7 9.7 0 0 0 7 2.858 12.312 12.312 0 0 0 9.119-4.307c1.9-2.145 4.166-6.041 4.166-12.419a21.281 21.281 0 0 0-6.273-15.155Z"
    />
  </svg>
);

export default SvgElectrical;
